import type { ICatalog, IModuleDefinition } from '@platform/core/types';
import { recordTypeOrder } from '../../shell/recordTypeOrder';
import type { IBuilderType } from './IBuilderType';
import { moduleRank } from './moduleRank';
import { typeRows } from './typeRows';

/**
 * «Визначення модулів» конструктора (прототип v4 bMods = ws.modules): реалізовані типи записів установлених модулів простору в порядку
 * прототипу для простору (recordTypeOrder: поле `order` каталогу, інакше порядок меню). Чиста функція.
 */
export function builderTypes(definitions: readonly IModuleDefinition[], catalog: ICatalog | undefined): IBuilderType[] {
  const at = recordTypeOrder(catalog, moduleRank());
  return typeRows(definitions).map(({ def, rt }) => ({ def, rt })).sort((a, b) => at(a.rt.key) - at(b.rt.key));
}
